import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from '../../components/Modal/CustomModal';
import DivContainerBody from '../../components/DivContainerBody';

const SendQrModal = (props) => {
    const { t } = useTranslation();

    const handleSend = (e) => {
        props?.onClickFn(e);
        props?.onHide();
    };
    return (
        <CustomModal
            title={t(props.title_modal)}
            size='md'
            buttonConfirm='confirm'
            {...props}
            onConfirm={() => {
                handleSend();
            }}
        >
            <DivContainerBody>
                <p className='d-flex justify-content-center align-content-center'>
                    {t(`${props?.description}`)}
                </p>
            </DivContainerBody>
        </CustomModal>
    );
};

export default SendQrModal;
